import cx from 'classnames';
import { Surface } from '@dx-ui/global-ui-prism';
import { DrawerPanel } from '@dx-ui/osc-drawer';
import type { PropsWithChildren } from 'react';
import { useHeaderContext } from '../../context/header-context';
import { useHeaderStateContext } from '../../context/header-state-context';

export const MobileAccountSidebar = ({ children }: PropsWithChildren) => {
  const {
    user: { user },

    visual: { surfaceType, isTranslucent },
    accessibility: { wrapperId },
  } = useHeaderContext();
  const {
    menuState: { isAccountOpen },
  } = useHeaderStateContext();

  const isOpen = !!user && isAccountOpen;
  return (
    <DrawerPanel
      isOpen={isOpen}
      alignment="right"
      appWrapperId={wrapperId}
      interactiveElementWrapperId="drawer-nav"
      className={cx('osc-nav-drawer', {
        '!bg-translucent bg-blur': isTranslucent,
      })}
    >
      <Surface
        type={surfaceType}
        className={cx('osc-nav-drawer h-full', {
          '!bg-transparent': isTranslucent,
        })}
      >
        {children}
      </Surface>
    </DrawerPanel>
  );
};
